import EditorJS from '@editorjs/editorjs';
import * as locales from './locales';

import NestedList from '@editorjs/nested-list';

import Table from 'adv-table';
import CustomParagraph from './components/block-paragraph';
import CustomHeader from './components/block-header';
import ImageBlock from './components/block-image';
import DocumentSectionBlock from './components/block-documentsection';

import Bold from './components/tune-bold';
import Italic from './components/tune-italic';
import Underline from './components/tune-underline';
import Alignement from './components/tune-alignment';
import CustomFieldSelector from './components/tune-customfield-selector';

import Undo from 'editorjs-undo';
import DragDrop from 'editorjs-drag-drop';


let subEditorTools = {
  paragraph: {
	class: CustomParagraph,
	inlineToolbar: true,
	shortcut: 'CMD+ALT+P',
	config: {
	  preserveBlank: true,
	}
  },
  header: {
	class: CustomHeader,
	inlineToolbar: true,
	shortcut: 'CMD+ALT+H',
	levels: [1, 2, 3, 4, 5, 6],
	defaultLevel: 3
  },
  list: {
	class: NestedList,
	inlineToolbar: true,
	shortcut: 'CMD+ALT+L',
	config: {
	  defaultStyle: 'unordered'
	},
  },
  image: {
	class: ImageBlock,
	shortcut: 'CMD+ALT+I',
  },
  table: {
	class: Table,
	inlineToolbar: true,
	shortcut: 'CMD+ALT+T',
	config: {
	  rows: 2,
	  cols: 3,
	},
  },
  custombold: {
	class: Bold,
	shortcut: 'CMD+B',
  },
  customitalic: {
	class: Italic,
	shortcut: 'CMD+I',
  },
  underline: {
	class: Underline,
	shortcut: 'CMD+U',
  },
  alignment: {
	class: Alignement,
	config: {
	  default: 'left',
	  blocks: {
		paragraph: 'justify',
		header: 'center',
	  }
	}
  },
  customfield: {
	class: CustomFieldSelector
  }
}

let mainTools = {
  paragraph: {
	inlineToolbar: true,
	shortcut: 'CMD+ALT+P',
	config: {
	  preserveBlank: true,
	}
  },
  header: {
	class: CustomHeader,
	inlineToolbar: true,
	shortcut: 'CMD+ALT+H',
	levels: [1, 2, 3, 4, 5, 6],
	defaultLevel: 3
  },
  list: {
	class: NestedList,
	inlineToolbar: true,
	shortcut: 'CMD+ALT+L',
	config: {
	  defaultStyle: 'unordered'
	},
  },
  image: {
	class: ImageBlock,
	shortcut: 'CMD+ALT+I',
  },
  table: {
	class: Table,
	inlineToolbar: true,
	shortcut: 'CMD+ALT+T',
	config: {
	  rows: 2,
	  cols: 3,
	},
  },
  documentsection: {
	class: DocumentSectionBlock,
	shortcut: 'CMD+ALT+S',
	config: {
	  editorJs: EditorJS,
	  tools: subEditorTools
	},
	tunes: []
  },
  custombold: {
	class: Bold,
	shortcut: 'CMD+B',
  },
  customitalic: {
	class: Italic,
	shortcut: 'CMD+I',
  },
  underline: {
	class: Underline,
	shortcut: 'CMD+U',
  },
  alignment: {
	class: Alignement,
	config: {
	  default: 'left',
	  blocks: {
		paragraph: 'justify',
		header: 'center',
	  }
	}
  },
  customfield: {
	class: CustomFieldSelector
  }
};

export function initEditorJS(selector) {

  const editorElement = document.querySelector(selector);
  const editor = new EditorJS({
	holder: editorElement,
	i18n: locales.it,
	autofocus: false,
	placeholder: 'Scrivi qualcosa...',
	minHeight: 50,
	inlineToolbar: ['custombold', 'customitalic', 'underline', 'customfield'],
	tools: mainTools,
	tunes: ['alignment'],
	//sanitize: {
	//  span: {
	//	id: true,
	//	contenteditable: true,
	//	class: true
	//  }
	//},
	onReady: () => {
	  //new Undo({ editor });
	  //new DragDrop(editor, "2px solid rgb(15 118 110)");
	}
  });

  return editor;
}